// @flow strict

import * as React from 'react';
import * as Types from '@ta/trips.trip-types';
import TrackImpression from './TrackImpression';

/**
 * Map the state of the trip home filter to the defined TripFilter
 */
const filter2TripFilter = {
  ALL_TRIPS: 'ALL',
  PUBLIC_TRIPS: 'PUBLIC',
  PRIVATE_TRIPS: 'PRIVATE',
};

type Props = {|
  trips: Types.Trip[],
  filterSelected: string,
  children: React.Node,
|};

const TripsHomeImpression = ({ trips, filterSelected, children }: Props) => (
  <TrackImpression
    source="tripsHome"
    attributes={{
      tripsHome: {
        hasTrips: trips && trips.length > 0,
        filter: filter2TripFilter[filterSelected] || 'ALL', // we default to 'all' so use that
      },
    }}
  >
    {children}
  </TrackImpression>
);

export default TripsHomeImpression;
